// Tab groups. Panels pair with tabs by matching data-panel/data-tab values when
// every tab carries one, and fall back to positional pairing otherwise.
// A root with [data-tabs-panels] and [data-tabs-bar] authors its buttons next
// to their panels: every child of the panels host is a panel, and the [data-tab]
// button it holds is lifted into the bar. A panel without one gets a generated
// button carrying the classes named by the data-tabs-bar value, labelled by the
// element the root's data-tabs-label selector names inside the panel, else the
// panel's [data-tab-label], else its first heading. Without the script every
// panel stays visible under its own tab, which is what the Designer shows.
import { onReady } from '../utils/ready.js';

export function initTabs() {
  onReady(function () {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var host = root.querySelector('[data-tabs-panels]');
      var strip = root.querySelector('[data-tabs-bar]');
      if (host && strip) {
        Array.prototype.slice.call(host.children).forEach(function (p) {
          if (p.hasAttribute('data-panel')) return;
          p.setAttribute('data-panel', '');
          var own = p.querySelector('[data-tab]');
          if (own) {
            strip.appendChild(own);
            return;
          }
          var label =
            (root.getAttribute('data-tabs-label') && p.querySelector(root.getAttribute('data-tabs-label'))) ||
            p.querySelector('[data-tab-label]') ||
            p.querySelector('h1,h2,h3,h4,h5,h6');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = strip.getAttribute('data-tabs-bar');
          b.setAttribute('data-tab', '');
          b.textContent = label ? label.textContent.trim() : '';
          strip.appendChild(b);
        });
      }
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
      if (!tabs.length || !panels.length) return;
      var bar = tabs[0].parentElement;
      var byValue = tabs.every(function (t) {
        return t.getAttribute('data-tab');
      });
      bar.setAttribute('role', 'tablist');
      tabs.forEach(function (t) {
        t.setAttribute('role', 'tab');
      });
      panels.forEach(function (p) {
        p.setAttribute('role', 'tabpanel');
      });
      function sel(i) {
        tabs.forEach(function (x, j) {
          x.classList.toggle('is-current', j === i);
          x.setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
        panels.forEach(function (p, j) {
          var on = byValue ? p.getAttribute('data-panel') === tabs[i].getAttribute('data-tab') : j === i;
          p.classList.toggle('is-current', on);
        });
      }
      root.classList.add('js-tabs');
      var cur = -1;
      tabs.forEach(function (t, i) {
        if (cur < 0 && t.classList.contains('is-current')) cur = i;
      });
      sel(cur < 0 ? 0 : cur);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          sel(i);
          if (bar.scrollWidth > bar.clientWidth) {
            bar.scrollTo({ left: t.offsetLeft - bar.offsetLeft, behavior: 'smooth' });
          }
        });
      });
    });
  });
}
